import { render, staticRenderFns } from "./AppDialogHeader.vue?vue&type=template&id=8c63ff52&scoped=true&"
import script from "./AppDialogHeader.vue?vue&type=script&lang=js&"
export * from "./AppDialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppDialogHeader.vue?vue&type=style&index=0&id=8c63ff52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c63ff52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardTitle,VDivider,VIcon})
